<template>
  <div>
    <el-tree
      :data="mansuriptRepoTree"
      :props="defaultProps"
      @node-click="handleNodeClick"
      :highlight-current='hightLight'
      element-loading-text="拼命加载中"
      :expand-on-click-node='expandOnClick'
      node-key="id"
      :show-checkbox='showCheckbox'
      :check-on-click-node='false'
      ref='mansuriptTreeRef'
      :check-strictly='checkStrictly'
      :default-expanded-keys='defaultExpandedKeys'
      v-loading="loading"
      @check-change='checkChange'
    >
      <span
        class="custom-tree-node"
        slot-scope="{ node, data }"
      >

        <span
          class="node_label"
          :title="node.label"
        >{{ node.label }}</span>

        <span
          class="el-iconfont el-icon-arrow-right"
          v-if='data.children && data.children.hasOwnProperty("length") && data.children.length>0 && !node.expanded'
        ></span>
        <span
          class="el-iconfont el-icon-arrow-down"
          v-if='data.children && data.children.hasOwnProperty("length") && data.children.length>0 && node.expanded'
        ></span>

      </span>
    </el-tree>
  </div>
</template>

<script>
import * as api from '../../../api'
export default {
  name: 'matterrepotree',
  props: {
    hightLight: {
      type: Boolean,
      required: true
    },
    showCheckbox: {
      type: Boolean,
      required: true
    },

    checkStrictly: {
      type: Boolean,
      required: true
    }
  },
  components: {

  },
  mounted () {

  },
  created () {

  },
  destroyed () {

  },
  data () {
    return {
      expandOnClick: true,
      mansuriptRepoTree: [],
      loading: false,
      currentRepoId: '',
      defaultExpandedKeys: []

    }
  },
  computed: {
    defaultProps () {
      var type = ''
      if (typeof (eval(this.$parent.$parent.getOperateType)) == "function") {
        type = this.$parent.$parent.getOperateType()
      }
      if (type === 'matterPosition') {
        return {
          children: 'children',
          label: 'name',
          disabled: function (data) {
            if (data.flag_repo || (data.id_repo && !(data.id_repo.indexOf('repository-personal') === -1))) {
              return true
            }
          }
        }
      } else {
        return {
          children: 'children',
          label: 'name',
          disabled: function (data) {
            if (data.flag_repo) {
              return true
            }
          }
        }
      }
    }
  },
  methods: {
    handleNodeClick (data, node, nodeSelf) {


    },
    setCurrentFolderPath () {
      for (var i = 0; i < this.mansuriptRepoTree.length; i++) {
        if (this.mansuriptRepoTree[i].id === this.currentRepoId) {
          return this.mansuriptRepoTree[i]
        }
      }
    },
    checkChange (data, checked) {
      if (checked) {
        var type = ''
        if (typeof (eval(this.$parent.$parent.getOperateType)) == "function") {
          type = this.$parent.$parent.getOperateType()
        }
        if (type === 'matterPosition' || type === 'picToMatter') {
          if (checked) {
            var arr = this.$refs.mansuriptTreeRef.getCheckedNodes()
            for (var i = 0; i < arr.length; i++) {
              this.$refs.mansuriptTreeRef.setChecked(arr[i])
            }
            this.$refs.mansuriptTreeRef.setChecked(data.id, true)
            this.$emit('checkChangeFolder', this.$refs.mansuriptTreeRef.getCheckedNodes())
          }
        } else {
          this.$emit('checkChangeFolderList', this.$refs.mansuriptTreeRef.getCheckedNodes())
        }

        this.currentRepoId = data.id_repo
        var currentNode = this.setCurrentFolderPath()
        this.getPathById(data.id, currentNode)
      }
    },
    getPathById (id, node) {
      var temppath = []
      try {
        function getNodePath (node) {
          temppath.push(node.name)
          if (node.id === id) {
            throw ("GOT IT!")
          }
          if (node.children && node.children.length > 0) {
            for (var i = 0; i < node.children.length; i++) {
              getNodePath(node.children[i])
            }
            temppath.pop()
          }
          else {
            temppath.pop()
          }
        }
        getNodePath(node)
      }
      catch (e) {
        console.log(e)
      }

      this.$emit('getmattersavepath', temppath)

    },

    //获取稿件库库列表
    getMansuriptData (data) {
      this.loading = true
      var option = {
        ...this.$store.getters.baseOption,
        'params': {}
      }
      var type = ''
      if (typeof (eval(this.$parent.$parent.getOperateType)) == "function") {
        type = this.$parent.$parent.getOperateType()
      }
      api._post(_MATTERREPOURL_ + 'get_repo_tree', option).then((resp) => {
        if (resp.code == 200) {
          this.mansuriptRepoTree = resp.data
          if (type === 'matterPosition') {
            for (var i = 0; i < this.mansuriptRepoTree.length; i++) {
              if (this.mansuriptRepoTree[i].id.indexOf('repository-personal') !== -1) {
                this.mansuriptRepoTree.splice(i, 1)
                break;
              }
            }
          }
          this.getLastFolderChoice(data)
        } else {
          this.mansuriptRepoTree = []
        }
        this.loading = false
      }).catch((error) => {
        this.mansuriptRepoTree = []
        this.loading = false
        console.log(error)
      })
    },

    getLastFolderChoice (data) {
      var folderId = data.id
      var repoId = data.id_repo
      this.defaultExpandedKeys = [folderId]
      this.$nextTick(function () {
        if (folderId) {
          this.$refs.mansuriptTreeRef.setCurrentKey(folderId)
          this.$refs.mansuriptTreeRef.setChecked(folderId, true)
          this.currentRepoId = repoId
          var currentNode = this.setCurrentFolderPath()
          this.getPathById(folderId, currentNode)
        }
      })
    }

  }
}
</script>

<style lang='stylus' scoped></style>
